module.exports = __webpack_public_path__ + "fonts/Mulish-BlackItalic.fc91cb43.ttf";